import { i18n } from 'common/boot/i18n';
import rules from 'common/helpers/rules';

const validationRules = {
  title: [
    (value) => rules.MIN_LENGTH(value, i18n.t('label.title'), 5),
    (value) => rules.MAX_LENGTH(value, i18n.t('label.title'), 125),
  ],
  login: [
    rules.REQUIRED,
  ],
  password: [
    rules.REQUIRED,
  ],
  mailChimpKey: [
    rules.MAIL_CHIMP_API_KEY,
  ],
  apiUrl: [
    rules.REQUIRED,
    rules.URL,
  ],
  apiKey: [
    rules.REQUIRED,
  ],
};

export const MAX_AUTORESPONDERS = 5;

export default [
  {
    value: ENUMS.AUTORESPONDER_TYPES.ACTIVE_CAMPAIGN,
    label: 'ActiveCampaign',
    fields: [
      {
        titleKey: 'label.title',
        name: 'title',
        options: {
          rules: validationRules.title,
        },
      },
      {
        titleKey: 'label.apiUrl',
        name: 'apiUrl',
        options: {
          rules: validationRules.apiUrl,
        },
      },
      {
        titleKey: 'label.apiKeyProvider',
        name: 'apiKey',
        options: {
          rules: validationRules.apiKey,
        },
      },
    ],
  },
  {
    value: ENUMS.AUTORESPONDER_TYPES.GET_RESPONSE,
    label: 'GetResponse',
    fields: [
      {
        titleKey: 'label.title',
        name: 'title',
        options: {
          rules: validationRules.title,
        },
      },
      {
        titleKey: 'label.apiKeyProvider',
        name: 'apiKey',
        options: {
          rules: validationRules.apiKey,
        },
      },
    ],
  },
  {
    value: ENUMS.AUTORESPONDER_TYPES.GOOGLE_SPREADSHEETS,
    label: 'Google SpreadSheets',
    fields: [
      {
        titleKey: 'label.title',
        name: 'title',
        options: {
          rules: validationRules.title,
        },
      },
      {
        titleKey: 'label.googleSpreadSheetUrl',
        name: 'url',
        options: {
          rules: validationRules.apiUrl,
          hint: i18n.t('text.addUserToSpreadSheet', [process.env.GOOGLE_SPREADSHEET_EMAIL]),
          'bottom-slots': true,
          placeholder: 'https://docs.google.com/spreadsheets/d/1345345345Ipf9DDYFfVAk_USYLIpmtAQBj56tUrzUk/edit#gid=0',
        },
      },
    ],
  },
  {
    value: ENUMS.AUTORESPONDER_TYPES.KLICK_TIPP,
    label: 'Klick Tipp',
    fields: [
      {
        titleKey: 'label.title',
        name: 'title',
        options: {
          rules: validationRules.title,
        },
      },
      {
        titleKey: 'label.login',
        name: 'login',
        options: {
          rules: validationRules.login,
        },
      },
      {
        titleKey: 'label.password',
        name: 'password',
        options: {
          rules: validationRules.password,
        },
      },
    ],
  },
  {
    value: ENUMS.AUTORESPONDER_TYPES.MAILCHIMP,
    label: 'MailChimp',
    fields: [
      {
        titleKey: 'label.title',
        name: 'title',
        options: {
          rules: validationRules.title,
        },
      },
      {
        titleKey: 'label.apiKeyProvider',
        name: 'apiKey',
        options: {
          rules: validationRules.mailChimpKey,
        },
      },
    ],
  },
  {
    value: ENUMS.AUTORESPONDER_TYPES.QUENTN,
    label: 'Quentn',
    fields: [
      {
        titleKey: 'label.title',
        name: 'title',
        options: {
          rules: validationRules.title,
        },
      },
      {
        titleKey: 'label.apiUrl',
        name: 'apiUrl',
        options: {
          rules: validationRules.apiUrl,
        },
      },
      {
        titleKey: 'label.apiKeyProvider',
        name: 'apiKey',
        options: {
          rules: validationRules.apiKey,
        },
      },
    ],
  },
];
